export default __webpack_public_path__ + "static/media/Pilgrim's Sandals of the Eldritch.0ce7e059.jpg";